var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-drawer",
    {
      attrs: {
        title: _vm.title,
        width: 800,
        placement: "right",
        closable: false,
        visible: _vm.visible,
      },
      on: { close: _vm.close },
    },
    [
      _c(
        "a-spin",
        { attrs: { spinning: _vm.confirmLoading } },
        [
          _c(
            "a-form-model",
            {
              ref: "form",
              attrs: { model: _vm.model, rules: _vm.validatorRules },
            },
            [
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "articleId",
                    label: "文章id",
                  },
                },
                [
                  _c("a-input", {
                    attrs: { placeholder: "请输入文章id" },
                    model: {
                      value: _vm.model.articleId,
                      callback: function ($$v) {
                        _vm.$set(_vm.model, "articleId", $$v)
                      },
                      expression: "model.articleId",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "viewerId",
                    label: "查看者id",
                  },
                },
                [
                  _c("a-input", {
                    attrs: { placeholder: "请输入查看者id" },
                    model: {
                      value: _vm.model.viewerId,
                      callback: function ($$v) {
                        _vm.$set(_vm.model, "viewerId", $$v)
                      },
                      expression: "model.viewerId",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "viewerName",
                    label: "查看者名称",
                  },
                },
                [
                  _c("a-input", {
                    attrs: { placeholder: "请输入查看者名称" },
                    model: {
                      value: _vm.model.viewerName,
                      callback: function ($$v) {
                        _vm.$set(_vm.model, "viewerName", $$v)
                      },
                      expression: "model.viewerName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "authorId",
                    label: "文章作者id",
                  },
                },
                [
                  _c("a-input", {
                    attrs: { placeholder: "请输入文章作者id" },
                    model: {
                      value: _vm.model.authorId,
                      callback: function ($$v) {
                        _vm.$set(_vm.model, "authorId", $$v)
                      },
                      expression: "model.authorId",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "type",
                    label: "1.浏览记录 2.展现记录（量）",
                  },
                },
                [
                  _c("a-input-number", {
                    model: {
                      value: _vm.model.type,
                      callback: function ($$v) {
                        _vm.$set(_vm.model, "type", $$v)
                      },
                      expression: "model.type",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "drawer-bootom-button" },
        [
          _c(
            "a-button",
            { attrs: { type: "primary" }, on: { click: _vm.handleOk } },
            [_vm._v("确定")]
          ),
          _c(
            "a-button",
            { attrs: { type: "primary" }, on: { click: _vm.handleCancel } },
            [_vm._v("取消")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }